<script lang="ts" setup>
const isLogoutForced = ref(false);
</script>

<template>
  <ModalUserIdleStart
    v-if="!isLogoutForced"
    @force-logout="isLogoutForced = true" />
  <ModalUserIdleEnd v-else />
</template>
